import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: false
})
export class NoResultsComponent {
  @Input() message: string = 'No results found';
}
